import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { SalesTaxNumberInput } from './SalesTaxNumberInput';

export function SalesTaxNumberField<TValues extends FieldValues>({
  name,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return <SalesTaxNumberInput value={value as string} onChange={onChange} />;
}
